import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contact-tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeTab: { type: String, default: "booking" }
  }

  connect() {
    console.log("Contact tabs controller connected")
    // Check if there's a hash in the URL to determine which tab to show
    const hash = window.location.hash.substring(1) // Remove the #
    const tabToShow = hash && (hash === 'contact' || hash === 'booking') ? hash : this.activeTabValue
    this.showTab(tabToShow)
  }

  switchTab(event) {
    const tabName = event.currentTarget.dataset.tab
    this.activeTabValue = tabName
    this.showTab(tabName)
  }

  showTab(tabName) {
    // Update tab button styles
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === tabName

      if (isActive) {
        tab.classList.add("border-b-4", "border-primary-green", "text-primary-green")
        tab.classList.remove("border-b-2", "border-gray-300", "text-gray-600")
      } else {
        tab.classList.remove("border-b-4", "border-primary-green", "text-primary-green")
        tab.classList.add("border-b-2", "border-gray-300", "text-gray-600")
      }
    })

    // Update panel visibility
    this.panelTargets.forEach(panel => {
      if (panel.dataset.panel === tabName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
